<template>
  <div class="form-outline pa-3">
    <form-legend :field="field" class="pt-1" />
    <v-btn class="my-2"  color="primary-action"  outlined :href="field.field_options.hyperlink" target="_blank" v-bind="darkOrLightMode">
      {{ field.field_options.hyperlink_text || 'Link' }}
    </v-btn>
    <legend v-html="field.field_options.description" :class="'v-label theme--' + mode" />
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
};
</script>
